import type { Opportunity } from '@axiom/validation';
import moment from 'moment';

import { TimeCopyUtil } from './time-copy-util';

export const TimeToSubmissionCopyUtil = (opportunity: Opportunity): string => {
  if (
    !opportunity.firstCandidateSubmittedAt &&
    opportunity.firstCandidateSelectedOrFurtherAt
  ) {
    return '';
  }
  if (!opportunity.timeToSubmission || opportunity.timeToSubmission.hours < 0) {
    return '';
  }
  if (opportunity.timeToSubmission.hours === 1) {
    return '1 Hr';
  }
  return opportunity.timeToSubmission.hours === 0 &&
    moment(opportunity.qualifiedAt) >
      moment(opportunity.firstCandidateSubmittedAt)
    ? ''
    : TimeCopyUtil.getHoursOrDaysCopyFromNumberOfHours(
        opportunity.timeToSubmission.hours
      );
};
